import React, { Component } from 'react'
import BaseModal from 'react-bootstrap/Modal'
import usingApps from './using-apps.mp4'

export class Modal extends Component {
  handleClose = () => {
    const { setShowVideo } = this.props
    setShowVideo(false)
  }

  render() {
    const { showVideo } = this.props
    return (
      <BaseModal show={showVideo} size="xl" onHide={this.handleClose}>
        <BaseModal.Header closeButton />
        <BaseModal.Body>
          <video src={usingApps} className="video-player" controls />
        </BaseModal.Body>
      </BaseModal>
    )
  }
}

export default Modal
